import React, { useCallback, useState } from 'react'
import EditNetworksModal from './EditNetworksModal'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    display: 'inline-block',
    cursor: 'pointer',
  },
}))

export default function EditNetworksButton({ vm }) {
  const classes = useStyles()
  const [showModal, setShowModal] = useState(false)

  const handleClick = useCallback(() => {
    setShowModal(true)
  }, [setShowModal])

  return (
    <>
      <div className={classes.icon} onClick={handleClick}>
        <FontAwesomeIcon size="md">edit</FontAwesomeIcon>
      </div>
      {showModal && <EditNetworksModal open onClose={() => setShowModal(false)} vm={vm} />}
    </>
  )
}
